(function () {
  if (window.__rrShippingReturnsReady) return;
  window.__rrShippingReturnsReady = true;
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-rr-policy-trigger]');
    if (!trigger) return;
    const target = document.querySelector('[data-rr-policy-help]');
    if (!target) return;
    const accordion = target.closest('details');
    if (accordion) accordion.open = true;
    const focus = target.querySelector('a') || target;
    if (focus === target) focus.tabIndex = -1;
    focus.focus({ preventScroll: true });
    const controls = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--rr-product-controls-height')) || 0;
    window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - controls - 16), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
})();
